import { useQuery } from "@tanstack/react-query";
import {
  getAdminRaffleRounds,
  type RaffleRoundStatus,
  type Region,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const ADMIN_RAFFLE_QUERY_KEY = "ADMIN_RAFFLE";

export type AdminRaffleRoundsParams = {
  region?: Region;
  status?: RaffleRoundStatus;
};

export const adminRaffleKeys = {
  all: [ADMIN_RAFFLE_QUERY_KEY],
  rounds: (params: AdminRaffleRoundsParams = {}) => [
    ...adminRaffleKeys.all,
    "rounds",
    params,
  ],
};

export const useAdminRaffleRoundsQuery = (
  params: AdminRaffleRoundsParams = {},
) =>
  useQuery({
    queryKey: adminRaffleKeys.rounds(params),
    queryFn: processResponseWithApiProblemDetails(() =>
      getAdminRaffleRounds(params.region, params.status),
    ),
  });
